import ReactMarkdown, { type Components } from "react-markdown";

// Descriptions synced from the Tech Radar are Jira text, and many carry Markdown — links to
// Confluence, lists, bold. Rendered here rather than shown raw. react-markdown never renders
// raw HTML, so synced text can't inject markup.

/** Compact styles for short descriptive text: links open in a new tab, headings are shrunk
 * to bold lines (a description's "## Why" shouldn't outrank the page's own headings). */
const COMPONENTS: Components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer" className="text-accent underline">
      {children}
    </a>
  ),
  p: ({ children }) => <p className="leading-relaxed">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-5">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-5">{children}</ol>,
  h1: ({ children }) => <p className="font-semibold">{children}</p>,
  h2: ({ children }) => <p className="font-semibold">{children}</p>,
  h3: ({ children }) => <p className="font-semibold">{children}</p>,
  h4: ({ children }) => <p className="font-semibold">{children}</p>,
  code: ({ children }) => <code className="rounded bg-sunken px-1 font-mono text-[0.9em]">{children}</code>,
};

/** Renders `text` as Markdown, paragraphs spaced apart. */
export function Markdown({ text, className }: { text: string; className?: string }) {
  return (
    <div className={`flex flex-col gap-2 ${className ?? ""}`}>
      <ReactMarkdown components={COMPONENTS}>{text}</ReactMarkdown>
    </div>
  );
}
